import { Module } from 'vuex';

import { RootState, EditableStatus } from '@/store/types';

import { RegionsState } from './types';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const getInitialState = (): RegionsState => ({
  /**
   * Edit
   */
  editableStatus: EditableStatus.Loading,
});

const state = getInitialState();

const module: Module<RegionsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default module;
